import React from 'react';
import { mergeClassNames } from 'utils/helpers';

interface IProps {
  children?: React.ReactNode;
  color: ButtonColors;
  variant?: ButtonVariants;
  loading?: boolean;
  type?: 'button' | 'submit';
  fullWidth?: boolean;
  disabled?: boolean;
  iconPosition?: 'start' | 'end';
  className?: string;
  buttonClassName?: string;
  onClick?: () => void;
}

const BUTTON_CLASS = {
  darkBlue: {
    outline:
      'border-2 bg-white border-darkBlue-100 text-darkBlue-100 disabled:text-darkBlue-60 disabled:border-darkBlue-60',
    text: 'bg-transparent border-transparent text-darkBlue-100 disabled:text-darkBlue-60',
    default:
      'border-2 bg-darkBlue-100 border-darkBlue-100 text-white disabled:bg-darkBlue-60'
  },
  lightBlue: {
    outline:
      'border-2 bg-white border-lightBlue-100 text-lightBlue-100 disabled:text-lightBlue-60 disabled:border-lightBlue-60',
    text: 'bg-transparent border-transparent text-lightBlue-100 disabled:text-lightBlue-60',
    default:
      'border-2 bg-lightBlue-100 border-lightBlue-100 text-white disabled:bg-lightBlue-60'
  },
  success: {
    outline:
      'border-2 bg-white border-green-600 text-green-600 disabled:text-green-400 disabled:border-green-400 hover:text-green-700 hover:border-green-700',
    text: 'bg-transparent border-transparent text-green-600 disabled:text-green-400 hover:text-green-700',
    default:
      'border-2 bg-green-600 border-green-600 text-white disabled:bg-green-400 hover:bg-green-700'
  },
  danger: {
    outline:
      'border-2 bg-white border-red-800 text-red-800 disabled:text-red-600 disabled:border-red-600 hover:text-red-900 hover:border-red-900',
    text: 'bg-transparent border-transparent text-red-800 disabled:text-red-600 hover:text-red-900',
    default:
      'border-2 bg-red-800 border-red-800 text-white disabled:bg-red-600 hover:bg-red-900'
  },
  info: {
    outline:
      'border-2 bg-white border-gray-500 text-gray-500 disabled:text-gray-400 disabled:border-gray-400 hover:text-gray-600 hover:border-gray-600',
    text: 'bg-transparent border-transparent text-gray-500 disabled:text-gray-400 hover:text-gray-600',
    default:
      'border-2 bg-gray-500 border-gray-500 text-white disabled:bg-gray-400 hover:bg-gray-600'
  }
} as const;

type ButtonVariants = 'default' | 'outline' | 'text';
type ButtonColors = keyof typeof BUTTON_CLASS;

const Button = ({
  children,
  color,
  variant = 'default',
  loading,
  fullWidth,
  disabled,
  type = 'button',
  className = '',
  onClick
}: IProps) => (
  <div className={mergeClassNames(className, { 'w-full': fullWidth })}>
    <button
      onClick={onClick}
      className={mergeClassNames(
        'border disabled:cursor-not-allowed rounded-lg flex justify-center items-center py-2 px-6',
        BUTTON_CLASS[color][variant],
        { 'w-full': fullWidth }
      )}
      disabled={disabled || loading}
      type={type}
    >
      {children}
    </button>
  </div>
);

export default Button;
